const addCssStyleOnOpen = (editor) => {
    
    if(editor !== undefined){
        editor.on("run:open-href-pop-up",()=>{
            const getDialog = () => document.querySelector('.gjs-mdl-content');
            const getDialog2 = () => document.querySelector('.gjs-mdl-title');
            const getDialog3 = () => document.querySelector('.gjs-mdl-header');
            const getDialog4 = () => document.querySelector('.gjs-mdl-dialog');
            
            if (getDialog() !== null) getDialog().classList.add('gjs-mdl-content2');
            if (getDialog() !== null) getDialog2().classList.add('gjs-mdl-title2');
            if (getDialog() !== null) getDialog3().classList.add('gjs-mdl-header2');
            if (getDialog() !== null) getDialog4().classList.add('gjs-mdl-dialog2');
        })
    }
    
}

const removeCssStyleOnOpenOtherModules= (editor) => {
    
    if(editor !== undefined){
        editor.on("modal:open",()=>{
            if (editor.Commands.isActive('open-href-pop-up') === false) {
                const getDialog = () => document.querySelector('.gjs-mdl-content');
                const getDialog2 = () => document.querySelector('.gjs-mdl-title');
                const getDialog3 = () => document.querySelector('.gjs-mdl-header');
                const getDialog4 = () => document.querySelector('.gjs-mdl-dialog');
                
                if (getDialog() !== null ) getDialog().classList.remove('gjs-mdl-content2');
                if (getDialog2() !== null ) getDialog2().classList.remove('gjs-mdl-title2');
                if (getDialog3() !== null ) getDialog3().classList.remove('gjs-mdl-header2');
                if (getDialog4() !== null ) getDialog4().classList.remove('gjs-mdl-dialog2');
            }
        })
    }  
}

const handleOpenHrefPopUPCss = (editor) => {
    
    addCssStyleOnOpen(editor);
    removeCssStyleOnOpenOtherModules(editor);

}

export default handleOpenHrefPopUPCss;